// extracted by mini-css-extract-plugin
export default {"buttonMain":"Button_buttonMain__NqNKo"};